import React, { Component } from "react";
import Translation from "../translation/translation";
import { Redirect } from "react-router-dom";
import $ from "jquery";
import Context from "../context/context";
import Comm from "../comm/comm";

class Groups extends Component {
    allChecked = false;

    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;
        var groups = Comm.Groups(sid);

        var permissions = Comm.Permissions(sid);

        this.state = {
            Groups: groups,
            Permissions: permissions,
            SelectedGroup: null,
            showError: false,
        };
        this.ToggleAll = this.ToggleAll.bind(this);
    }

    ShowGroup(group) {
        this.setState({ SelectedGroup: group, showError: false });
    }

    NewGroup() {
        this.setState({ SelectedGroup: { id: null, name: "", permissions: [] } });
    }

    Save() {
        var gn = $("#tbGroupName").val();
        if (gn === "") {
            this.setState({ showError: true });
            return;
        }

        var sid = Context.IsLogged().Sid;
        var data = {
            id: this.state.SelectedGroup.id,
            name: gn,
            permissions: {},
        };

        $("input[id^='cbPermission']:checked").each(function (i, e) {
            var val = $(e).attr("permvalue");
            data.permissions[val] = 1;
        });
        sid = Context.GetContext().Sid;
        Comm.SaveGroup(sid, data);
        this.setState({
            Groups: Comm.Groups(sid),
            SelectedGroup: null,
            showError: false,
        });
    }

    ToggleAll() {
        this.allChecked = !this.allChecked;
        var ch = this.allChecked;
        $("input[id^='cbPermission']").each(function (i, e) {
            $(e).prop("checked", ch);
        });
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        var groups = this.state.Groups.slice();

        return Context.HasRight("rgroups") === true ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("groups")}</div>
                <div className="panel-body">
                    {Context.HasRight("egroups") ? (
                        <button className="btn btn-primary" onClick={() => this.NewGroup()}>
                            {Translation.Trans("newgroup")}
                        </button>
                    ) : null}
                    <br />
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-2">
                            {groups.map((obj) => (
                                <p>
                                    <span
                                        className={
                                            this.state.SelectedGroup !== null &&
                                            this.state.SelectedGroup.id === obj.id
                                                ? "btn btn-warning"
                                                : null
                                        }
                                    >
                                        <a onClick={() => this.ShowGroup(obj)} className="pointhand">
                                            {obj.name}
                                        </a>
                                    </span>
                                </p>
                            ))}
                        </div>

                        <div className="col-md-10">
                            {this.state.SelectedGroup !== null ? (
                                <div id="dData" className="borderDiv">
                                    <div className="row">
                                        <div className="col-md-12">
                                            {Context.HasRight("egroups") ? (
                                                <button
                                                    className="btn btn-primary pull-right"
                                                    onClick={() => this.Save()}
                                                >
                                                    {Translation.Trans("save")}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={Translation.Trans("groupname")}
                                                id="tbGroupName"
                                                defaultValue={this.state.SelectedGroup.name}
                                                key={this.state.SelectedGroup.id}
                                            ></input>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-10">
                                            {this.state.showError ? (
                                                <div className="alert alert-danger">
                                                    {Translation.Trans("entervalue")}
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <a onClick={() => this.ToggleAll()} className="pointhand">
                                                {Translation.Trans("all")}
                                            </a>
                                        </div>
                                        <div className="col-md-6">
                                            {this.state.Permissions.map((obj) => (
                                                <div className="checkbox">
                                                    <input
                                                        id={"cbPermission" + obj}
                                                        type="checkbox"
                                                        permvalue={obj}
                                                        key={obj + "_" + this.state.SelectedGroup.id}
                                                        defaultChecked={this.state.SelectedGroup.permissions.hasOwnProperty(
                                                            obj
                                                        )}
                                                    />
                                                    <label for={"cbPermission" + obj}>
                                                        {Translation.Trans(obj)}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default Groups;



// WEBPACK FOOTER //
// ./src/pages/groups.js